import { CombineDrillsType, GlobalFilterTeamsType, Month, Week } from '../../store/types';
import { PositionsGroupsType } from '../../components/Shared/Filters/PositionFilter';
import * as DateFns from 'date-fns';
import { ShowDistanceGraphsType } from '../../components/Shared/Filters/ShowDistanceGraph';
import {
  IntensitySimpleMultiSelectorItem,
  QuarterSimpleMultiSelectorItem,
  StatusSimpleMultiSelectorItem,
  YearSimpleSelectorItem
} from '../../components/Shared/Filters/type';
import { CustomTablesHeaderType } from 'components/Shared/Filters/CustomTableFilter';

// Date Range Selector
export const DEFAULT_WEEK_COMPARE_TO_DATA: Week = {
  weekNameAbbr: 'Select',
  weekName: 'Select',
  ts: 0,
  week: -1,
  startOfWeek: '',
  endOfWeek: ''
};

export const LABEL_DEFAULT_DAYS_COMPARE_TO_DATA: { label: string, days: 7 | 14 | 28 }[] = [
  { label: 'Past 7 Days (Default)', days: 7 },
  { label: 'Past 14 Days', days: 14 },
  { label: 'Past 28 Days', days: 28 }
];

// Positions
export const POSITIONS: PositionsGroupsType = [
  {
    groupLabel: 'QB',
    options: [
      { label: 'QB Quarterback', key: 'QB' }
    ]
  },
  {
    groupLabel: 'RB',
    options: [
      { label: 'RB Running Back', key: 'RB' },
      { label: 'FB Fullback', key: 'FB' }
    ]
  },
  {
    groupLabel: 'WR',
    options: [
      { label: 'WR Wide Receiver', key: 'WR' },
      { label: 'WO Wideout', key: 'WO' }
    ]
  },
  {
    groupLabel: 'TE',
    options: [
      { label: 'TE Tight End', key: 'TE' }
    ]
  },
  {
    groupLabel: 'OL',
    options: [
      { label: 'OL Offensive Lineman', key: 'OL' },
      { label: 'T Tackle', key: 'T' },
      { label: 'OT Offensive Tackle', key: 'OT' },
      { label: 'G Guard', key: 'G' },
      { label: 'OG Offensive Guard', key: 'OG' },
      { label: 'C Center', key: 'C' },
      { label: 'OC Offensive Center', key: 'OC' }
    ]
  },
  {
    groupLabel: 'DL',
    options: [
      { label: 'DL Defensive Lineman', key: 'DL' },
      { label: 'DT Defensive Tackle', key: 'DT' },
      { label: 'IDL Interior Defensive Lineman', key: 'IDL'},
      { label: 'NT Nose Tackle', key: 'NT' },
      { label: 'DE Defensive End', key: 'DE' },
      { label: 'EDGE Edge', key: 'EDGE'},
    ]
  },
  {
    groupLabel: 'LB',
    options: [
      { label: 'LB Linebacker', key: 'LB' },
      { label: 'OLB Outside Linebacker', key: 'OLB' },
      { label: 'MLB Middle Linebacker', key: 'MLB' },
      { label: 'ILB Inside Linebacker', key: 'ILB' },
      { label: 'MIKE Mike Linebacker', key: 'MIKE' },
      { label: 'WILL Will Linebacker', key: 'WILL' },
      { label: 'SAM Sam Linebacker', key: 'SAM' }
    ]
  },
  {
    groupLabel: 'DB',
    options: [
      { label: 'DB Defensive Back', key: 'DB' },
      { label: 'DS Defensive Safety', key: 'DS' },
      { label: 'DC Defensive Corner', key: 'DC'},
      { label: 'CB Cornerback', key: 'CB' },
      { label: 'S Safety', key: 'S' },
      { label: 'SAF Safety', key: 'SAF' },
      { label: 'FS Free Safety', key: 'FS' },
      { label: 'SS Strong Safety', key: 'SS' },
      { label: 'STAR Star', key: 'Star' }
    ]
  },
  {
    groupLabel: 'SPEC',
    options: [
      { label: 'K Kicker', key: 'K' },
      { label: 'P Punter', key: 'P' },
      { label: 'PK Placekicker', key: 'PK' },
      { label: 'LS Long Snapper', key: 'LS' }
    ]
  },
];

export const DEFENSE_KEYS_POSITION: string[] = [];
(() => POSITIONS.forEach(group => {
  if(group.groupLabel === 'DL' ){
    group.options.forEach(option => DEFENSE_KEYS_POSITION.push(option.key));
  }
  if(group.groupLabel === 'DB' ){
    group.options.forEach(option => DEFENSE_KEYS_POSITION.push(option.key));
  }
  if(group.groupLabel === 'LB' ){
    group.options.forEach(option => DEFENSE_KEYS_POSITION.push(option.key));
  }
}))();

export const OFFENSE_KEYS_POSITION: string[] = [];
(() => POSITIONS.forEach(group => {
  if(group.groupLabel === 'QB' ){
    group.options.forEach(option => OFFENSE_KEYS_POSITION.push(option.key));
  }
  if(group.groupLabel === 'RB' ){
    group.options.forEach(option => OFFENSE_KEYS_POSITION.push(option.key));
  }
  if(group.groupLabel === 'WR' ){
    group.options.forEach(option => OFFENSE_KEYS_POSITION.push(option.key));
  }
  if(group.groupLabel === 'TE' ){
    group.options.forEach(option => OFFENSE_KEYS_POSITION.push(option.key));
  }
  if(group.groupLabel === 'OL' ){
    group.options.forEach(option => OFFENSE_KEYS_POSITION.push(option.key));
  }
}))();

export const SPEC_KEYS_POSITION: string[] = [];
(() => POSITIONS.forEach(group => {
  if(group.groupLabel === 'SPEC' ){
    group.options.forEach(option => SPEC_KEYS_POSITION.push(option.key));
  }
}))();

export const CUSTOM_TABLE_FILTER: CustomTablesHeaderType = [
      {label: 'Time Moving',  key: '0.0'},
      {label: 'Total Dist',  key: '0.1'},
      {label: 'Team Target MPH',  key: '0.2'},
      {label: 'Team Walk YDS',  key: '0.3'},
      {label: 'Team Jog YDS',  key: '0.4'},
      {label: 'Team Run YDS',  key: '0.5'},
      {label: 'Team Sprint YDS',  key: '0.6'},
      {label: 'Team Max Sprint YDS',  key: '0.7'},
      {label: 'YDS 10+',  key: '0.8'},
      {label: 'Team Walk Time',  key: '0.9'},
      {label: 'Team Jog Time',  key: '0.10'},
      {label: 'Team Run Time',  key: '0.11'},
      {label: 'Team Sprint Time',  key: '0.12'},
      {label: 'Team Max Sprint Time',  key: '0.13'},
      {label: 'Time 10+',  key: '0.14'},
      {label: 'Team Hard Effort Dist',  key: '0.15'},
      {label: 'Team Walk Count',  key: '0.16'},
      {label: 'Team Jog Count',  key: '0.17'},
      {label: 'Team Run Count',  key: '0.18'},
      {label: 'Team Sprint Count',  key: '0.19'},
      {label: 'Team Max Sprint Count',  key: '0.20'},
      {label: 'Rel Target MPH',  key: '1.2'},
      {label: 'Rel Walk YDS',  key: '1.3'},
      {label: 'Rel Jog YDS',  key: '1.4'},
      {label: 'Rel Run YDS',  key: '1.5'},
      {label: 'Rel Sprint YDS',  key: '1.6'},
      {label: 'Rel Max Sprint YDS',  key: '1.7'},
      {label: 'Rel Walk Time',  key: '1.8'},
      {label: 'Rel Jog Time',  key: '1.9'},
      {label: 'Rel Run Time',  key: '1.10'},
      {label: 'Rel Sprint Time',  key: '1.11'},
      {label: 'Rel Max Sprint Time',  key: '1.12'},
      {label: 'Rel Hard Effort Dist',  key: '1.13'},
      {label: 'Rel Walk Count',  key: '1.14'},
      {label: 'Rel Jog Count',  key: '1.15'},
      {label: 'Rel Run Count',  key: '1.16'},
      {label: 'Rel Sprint Count',  key: '1.17'},
      {label: 'Rel Max Sprint Count',  key: '1.18'},
      //CUSTOM ZONES
      {label: 'Cust Target MPH',  key: '5.2'},
      {label: 'Cust Walk YDS',  key: '5.3'},
      {label: 'Cust Jog YDS',  key: '5.4'},
      {label: 'Cust Run YDS',  key: '5.5'},
      {label: 'Cust Sprint YDS',  key: '5.6'},
      {label: 'Cust Max Sprint YDS',  key: '5.7'},
      {label: 'Cust Walk Time',  key: '5.8'},
      {label: 'Cust Jog Time',  key: '5.9'},
      {label: 'Cust Run Time',  key: '5.10'},
      {label: 'Cust Sprint Time',  key: '5.11'},
      {label: 'Cust Max Sprint Time',  key: '5.12'},
      {label: 'Cust Hard Effort YDS',  key: '5.13'},
      {label: 'Cust Walk Count',  key: '5.14'},
      {label: 'Cust Jog Count',  key: '5.15'},
      {label: 'Cust Run Count',  key: '5.16'},
      {label: 'Cust Sprint Count',  key: '5.17'},
      {label: 'Cust Max Sprint Count',  key: '5.18'},
      //
      {label: 'Time Tracked',  key: '2.0'},
      {label: 'YDS/MIN',  key: '2.2'},
      {label: 'ACT AVG YPS',  key: '2.3'},
      {label: 'ACT AVG MPH',  key: '2.4'},
      {label: 'Accel/MIN',  key: '2.5'},
      {label: 'Decel/MIN',  key: '2.6'},
      {label: 'Max YPS',  key: '2.7'},
      {label: 'Max MPH',  key: '2.8'},
      {label: 'Explosive Effort',  key: '2.9'},
      {label: 'Max Stnd YPS',  key: '2.10'},
      {label: 'Max Stnd MPH',  key: '2.11'},
      {label: 'Total Accels',  key: '3.2'},
      {label: 'Accel Low',  key: '3.3'},
      {label: 'Accel Med',  key: '3.4'},
      {label: 'Accel High',  key: '3.5'},
      {label: 'Accel Dist Low',  key: '3.6'},
      {label: 'Accel Dist Med',  key: '3.7'},
      {label: 'Accel Dist High',  key: '3.8'},
      {label: 'Total Decels',  key: '3.9'},
      {label: 'Decels Low',  key: '3.10'},
      {label: 'Decels Med',  key: '3.11'},
      {label: 'Decels High',  key: '3.12'},
      {label: 'Decel Dist Low',  key: '3.13'},
      {label: 'Decel Dist Med',  key: '3.14'},
      {label: 'Decel Dist High',  key: '3.15'},
      {label: 'Exertion Index',  key: '3.16'},
      {label: 'Player Load',  key: '3.17'},
      {label: 'Max Accel',  key: '3.18'},
      {label: 'Max Stnd Accel',  key: '3.19'},
      {label: 'Max Decel',  key: '3.20'},
      {label: 'Max Stnd Decel',  key: '3.21'},
      {label: 'Accels at 20% Max Spd',  key: '3.22'},
      {label: 'Accels at 30% Max Spd',  key: '3.23'},
      {label: 'Accels at 40% Max Spd',  key: '3.24'},
      {label: 'Accels at 50% Max Spd',  key: '3.25'},
      {label: 'Accels at 60% Max Spd',  key: '3.26'},
      {label: 'Accels at 60%+ Max Spd',  key: '3.27'},
      {label: 'Decels at 20% Max Spd',  key: '3.28'},
      {label: 'Decels at 30% Max Spd',  key: '3.29'},
      {label: 'Decels at 40% Max Spd',  key: '3.30'},
      {label: 'Decels at 50% Max Spd',  key: '3.31'},
      {label: 'Decels at 60% Max Spd',  key: '3.32'},
      {label: 'Decels at 60%+ Max Spd', key: '3.33'},
      {label: 'Cumulative Load', key: '4.0' },
      {label: 'Load Bias', key: '4.1' },
      {label: 'Left Low Lateral Load',   key: '4.2'},
      {label: 'Left Medium Lateral Load',   key: '4.3'},
      {label: 'Left High Lateral Load',  key: '4.4'},
      {label: 'Right Low Lateral Load',  key: '4.5'},
      {label: 'Right Medium Lateral Load ',  key: '4.6'},
      {label: 'Right High Lateral Load', key: '4.7'},
];

export const ALL_TALBE_COLUMNS: string[] = [];
(()=> CUSTOM_TABLE_FILTER.forEach(option => ALL_TALBE_COLUMNS.push(option.key)))();

export const CUSTOM_LIVE_TABLE_FILTER: CustomTablesHeaderType = [
  //SPEED
  {label: 'Team Target Speed',  key: '0.0'},
  {label: 'Rel Target Speed', key: '0.1'},
  {label: 'Team Max Speed',  key: '0.2'},
  {label: 'Rel Max Speed',  key: '0.3'},
  {label: 'Team Max Sust. Speed',  key: '0.4'},
  {label: 'Rel Max Sust. Speed',  key: '0.5'},
  {label: 'Team Time Since X% of Max',  key: '0.6'},
  {label: 'Rel Time Since X% of Max',  key: '0.7'},
  //DISTANCES
  {label: 'Total Dist',  key: '1.0'},
  {label: 'Team Hard Effort YDS',  key: '1.1'},
  {label: 'Rel Hard Effort YDS',  key: '1.2'},
  {label: 'Team Walk YDS',  key: '1.3'},
  {label: 'Rel Walk YDS',  key: '1.4'},
  {label: 'Team Jog YDS',  key: '1.5'},
  {label: 'Rel Jog YDS',  key: '1.6'},
  {label: 'Team Run YDS',  key: '1.7'},
  {label: 'Rel Run YDS',  key: '1.8'},
  {label: 'Team Sprint YDS',  key: '1.9'},
  {label: 'Rel Sprint YDS',  key: '1.10'},
  {label: 'Team Max Sprint YDS',  key: '1.11'},
  {label: 'Rel Max Sprint YDS',  key: '1.12'},
  //COUNTS 
  {label: 'Team Walk Count',  key: '2.0'},
  {label: 'Rel Walk Count',  key: '2.1'},
  {label: 'Team Jog Count',  key: '2.2'},
  {label: 'Rel Jog Count',  key: '2.3'},
  {label: 'Team Run Count',  key: '2.4'},
  {label: 'Rel Run Count',  key: '2.5'},
  {label: 'Team Sprint Count',  key: '2.6'},
  {label: 'Rel Sprint Count',  key: '2.7'},
  {label: 'Team Max Sprint Count',  key: '2.8'},
  {label: 'Rel Max Sprint Count',  key: '2.9'},
  //CUSTOM ZONES
  { label: 'Cust Target Speed', key: '5.0' },
  { label: 'Cust Max Speed', key: '5.1' },
  { label: 'Cust Max Sust. Speed', key: '5.2' },
  { label: 'Cust Time Since X% Of Max', key: '5.3' },
  { label: 'Cust Hard Effort YDS', key: '5.4' },
  { label: 'Cust Walk YDS', key: '5.5' },
  { label: 'Cust Jog YDS', key: '5.6' },
  { label: 'Cust Run YDS', key: '5.7' },
  { label: 'Cust Sprint YDS', key: '5.8' },
  { label: 'Cust Max Sprint YDS', key: '5.9' },
  { label: 'Cust Walk Count', key: '5.10' },
  { label: 'Cust Jog Count', key: '5.11' },
  { label: 'Cust Run Count', key: '5.12' },
  { label: 'Cust Spring Count', key: '5.13' },
  { label: 'Cust Max Sprint Count', key: '5.14' },
  //ACCEL COUNTS
  {label: 'Accel Low',  key: '3.0'},
  {label: 'Accel Med',  key: '3.1'},
  {label: 'Accel High',  key: '3.2'},
  {label: 'Max Stnd Accel',  key: '3.3'},
  //DECEL COUNTS
  {label: 'Decel Low',  key: '4.0'},
  {label: 'Decel Med',  key: '4.1'},
  {label: 'Decel High',  key: '4.2'},
  {label: 'Max Stnd Decel',  key: '4.3'},
  //LOAD METRICS 
  {label: 'Cumulative Load', key: '6.0' },
  {label: 'Load Bias', key: '6.1' },
];

export const LIVE_ALERTING_TABLE_FILTER: CustomTablesHeaderType = [
 
  //DISTANCES
  {label: 'Total Dist',  key: '1.0'},
  {label: 'Team Hard Effort YDS',  key: '1.1'},
  {label: 'Rel Hard Effort YDS',  key: '1.2'},
  {label: 'Cust Hard Effort YDS',  key: '5.13'},
   //SPEED
  {label: 'Speed', key: '0.8' },
  {label: 'Team Walk YDS',  key: '1.3'},
  {label: 'Rel Walk YDS',  key: '1.4'},
  {label: 'Cust Walk YDS',  key: '5.3'},
  {label: 'Team Jog YDS',  key: '1.5'}, 
  {label: 'Rel Jog YDS',  key: '1.6'},
  {label: 'Cust Jog YDS',  key: '5.4'},
  {label: 'Team Run YDS',  key: '1.7'},
  {label: 'Rel Run YDS',  key: '1.8'},
  {label: 'Cust Run YDS',  key: '5.5'},
  {label: 'Team Sprint YDS',  key: '1.9'},
  {label: 'Rel Sprint YDS',  key: '1.10'},
  {label: 'Cust Sprint YDS',  key: '5.6'},
  {label: 'Team Max Sprint YDS',  key: '1.11'},
  {label: 'Rel Max Sprint YDS',  key: '1.12'},
  {label: 'Cust Max Sprint YDS',  key: '5.7'},
  //COUNTS 
  {label: 'Team Walk Count',  key: '2.0'},
  {label: 'Rel Walk Count',  key: '2.1'},
  {label: 'Cust Walk Count',  key: '5.14'},
  {label: 'Team Jog Count',  key: '2.2'},
  {label: 'Rel Jog Count',  key: '2.3'},
  {label: 'Cust Jog Count',  key: '5.15'},
  {label: 'Team Run Count',  key: '2.4'},
  {label: 'Rel Run Count',  key: '2.5'},
  {label: 'Cust Run Count',  key: '5.16'},
  {label: 'Team Sprint Count',  key: '2.6'},
  {label: 'Rel Sprint Count',  key: '2.7'},
  {label: 'Cust Sprint Count',  key: '5.17'},
  {label: 'Team Max Sprint Count',  key: '2.8'},
  {label: 'Rel Max Sprint Count',  key: '2.9'},
  {label: 'Cust Max Sprint Count',  key: '5.18'},
  //ACCEL COUNTS
  {label: 'Accel Low',  key: '3.0'},
  {label: 'Accel Med',  key: '3.1'},
  {label: 'Accel High',  key: '3.2'},
  {label: 'Max Stnd Accel',  key: '3.3'},
  //DECEL COUNTS
  {label: 'Decel Low',  key: '4.0'},
  {label: 'Decel Med',  key: '4.1'},
  {label: 'Decel High',  key: '4.2'},
  {label: 'Max Stnd Decel',  key: '4.3'},
  {label: 'Cumulative Load', key: '6.0' },
  {label: 'Load Bias', key: '6.1' },
];
export const ALL_LIVE_TALBE_COLUMNS: string[] = [];
(()=> CUSTOM_LIVE_TABLE_FILTER.forEach(option => ALL_LIVE_TALBE_COLUMNS.push(option.key)))();

export const ALERTING_TALBE_COLUMNS: string[] = [];
(()=> LIVE_ALERTING_TABLE_FILTER.forEach(option => ALERTING_TALBE_COLUMNS.push(option.key)))();


export const ALL_KEYS_POSITION: string[] = [];
(() => POSITIONS.forEach(group => group.options.forEach(option => ALL_KEYS_POSITION.push(option.key))))();

export const ALL_KEYS_POSITION_BALL_METRICS_TAB = ['QB', 'K', 'P', 'PK', 'LS'];

// Distance Graph selector
export const SHOW_DISTANCE_GRAPHS: ShowDistanceGraphsType = {
  name: 'Show Distance Graphs',
  types: [
    { name: 'All Zones' },
    { name: 'Hard Effort Zones' },
    { name: 'Run' },
    { name: 'Sprint' },
    { name: 'Max Sprint' }
  ],
  title: 'SHOW DISTANCE GRAPHS'
};

// Teams
export const GLOBAL_FILTER_TEAMS_EMPTY: GlobalFilterTeamsType = { nfl: {}, ncaa: [] };

export const YEARS = (() => {
  const years = [];
  const now = new Date().getFullYear();
  for (let year = 2015; year <= now; year++) {
    years.push(year);
  }
  return years;
})();

export const THRESHOLD =[
  {value: 800000, label: 'Select'},
  {value: 70, label: '70%'},
  {value: 80, label: '80%'},
  {value: 90, label: '90%'},
  {value: 100, label: '100%'},
];

export const OFF_SEASON_MONTHS: { [key: number]: Month[] } = {};

for (const year of YEARS) {
  OFF_SEASON_MONTHS[year] = [];
  for (let month = 2; month <= (year === 2020 ? 8 : 7); month++) { // March to August
    const date = new Date(year, month, 1, 0, 0, 0, 0);
    OFF_SEASON_MONTHS[year].push(
      {
        startOfMonth: DateFns.format(date, 'yyyy-MM-dd'),
        endOfMonth: DateFns.format(DateFns.endOfMonth(date), 'yyyy-MM-dd'),
        monthName: DateFns.format(date, 'MMMM')
      }
    );
  }
  const date = new Date(year + 1, 1, 1, 0, 0, 0, 0);
  OFF_SEASON_MONTHS[year].push(
    {
      startOfMonth: DateFns.format(date, 'yyyy-MM-dd'),
      endOfMonth: DateFns.format(DateFns.endOfMonth(date), 'yyyy-MM-dd'),
      monthName: DateFns.format(date, 'MMMM') + ' ' + (year + 1)
    }
  );
}

export const ALL_SEASON_MONTHS: { [key: number]: Month[] } = {};
const MONTHS = 12;
for (const year of YEARS) {
  ALL_SEASON_MONTHS[year] = [];
  for (let month = 0; month < MONTHS; month++) {
    const date = new Date(year, month, 1, 0, 0, 0, 0);
    ALL_SEASON_MONTHS[year].push(
      {
        startOfMonth: DateFns.format(date, 'yyyy-MM-dd'),
        endOfMonth: DateFns.format(DateFns.endOfMonth(date), 'yyyy-MM-dd'),
        monthName: DateFns.format(date, 'MMMM')
      }
    );
  }
}

export enum FILTER_KEYS {
  EVENTS = 'events',
  ZONE_TYPE = 'zoneType',
  VENUE = 'venue',
  TEAM_ID = 'teamId',
  TEAM_IDS = 'teamIds',
  TIME_SINCE_MAX = 'timeSinceMax',
  DATE_RANGE = 'dateRange',
  POSITIONS = 'positions',
  SHOW_DISTANCE_GRAPHS = 'showDistanceGraphs',
  VIEW = 'viewData',
  VIEW_LIVE= 'viewLive',
  YEAR = 'year',
  SEASON = 'season',
  TIME_SLIDER = 'timeSlider',
  PERIODS = 'periods',
  PRACTICES_DATE_RANGE_SELECTOR = 'PRACTICES_DATE_RANGE_SELECTOR',
  LEAGUE = 'league',
  SIMPLE_LEAGUE = 'simpleLeague',
  INTENSITY = 'intensity',
  TARGETED_RETRACK = 'tRetrack',
  SPEED_ZONE_TYPE = 'zoneType',
  QUARTER = 'quarter',
  PERIOD_TYPE = 'PERIOD TYPE',
  PLAY_TYPE = 'playType',
  SEASON_YEAR = 'seasonYear',
  FLIGHT_TYPE = 'flightType',
  CUSTOM_TABLE = 'customTable',
  CUSTOM_LIVE_TABLE = 'customLiveTable',
  PLAYERS_ALERT = 'playersAlert',
  STATUS_TRACKING = 'statusTracking'
}

export enum FILTER_GLOBAL_KEYS {
  WEEKS = 'WEEKS',
  TEAMS = 'TEAMS',
  VENUES = 'VENUES',
  PRACTICES_DATE_RANGE_SELECTOR = 'PRACTICES_DATE_RANGE_SELECTOR'
}

// Simple year filter
export const YEARS_FILTER: { name: string, types: YearSimpleSelectorItem[], defaultIndex: number, title: string, filterKey: FILTER_KEYS.SEASON_YEAR } = {
  name: 'Year',
  types: [...YEARS].reverse().map(year => ({ value: year, name: '' + year })),
  defaultIndex: 0,
  title: 'YEAR',
  filterKey: FILTER_KEYS.SEASON_YEAR
};
//TO DO ERASE INTENSITY CONSTANT AFTER TESTNIG
/*export const INTENSITY: { name: string, types: IntensitySimpleMultiSelectorItem[], title: string, filterKey: FILTER_KEYS.INTENSITY } = {
  name: 'Intensity',
  types: [
    { value: 'Low', name: 'Low' },
    { value: 'Medium', name: 'Medium' },
    { value: 'High', name: 'High' },
    { value: 'Walk-Through', name: 'Walk-Through' },
    { value: 'Workout', name: 'Workout' },
    { value: 'Pre-Practice', name: 'Pre-Practice' },
    { value: 'Rehab', name: 'Rehab' },
    { value: 'KO-6', name: 'KO-6' },
    { value: 'KO-5', name: 'KO-5' },
    { value: 'KO-4', name: 'KO-4' },
    { value: 'KO-3', name: 'KO-3' },
    { value: 'KO-2', name: 'KO-2' },
    { value: 'KO-1', name: 'KO-1' },
    { value: 'Padded', name: 'Padded' },
    { value: 'Shells', name: 'Shells' },
    { value: 'GD-6', name: 'GD-6' },
    { value: 'GD-5', name: 'GD-5' },
    { value: 'GD-4', name: 'GD-4' },
    { value: 'GD-3', name: 'GD-3' },
    { value: 'GD-2', name: 'GD-2' },
    { value: 'GD-1', name: 'GD-1'}
  ],
  title: 'INTENSITY',
  filterKey: FILTER_KEYS.INTENSITY
};
*/
export const QUARTER: { name: string, types: QuarterSimpleMultiSelectorItem[], title: string, filterKey: FILTER_KEYS.QUARTER } = {
  name: 'Quarter',
  types: [
    { value: 'Q0', name:'Pre-Game'},
    { value: 'Q1', name: 'Q1' },
    { value: 'Q2', name: 'Q2' },
    { value: 'Q3', name: 'Q3' },
    { value: 'Q4', name: 'Q4' },
    { value: 'Q5', name: 'OT' }
  ],
  title: 'QUARTER',
  filterKey: FILTER_KEYS.QUARTER
};

export const STATUS_FILTER: { name: string, types: StatusSimpleMultiSelectorItem[], title: string, filterKey: FILTER_KEYS.STATUS_TRACKING} = {
  name: 'Status',
  types: [
    { value: 'ACT', name:'ACT'},
    { value: 'DEV', name: 'DEV' },
    { value: 'CUT', name: 'CUT' },
    { value: 'RES', name: 'RES' }
  ],
  title: 'STATUS',
  filterKey: FILTER_KEYS.STATUS_TRACKING
};

export enum FORCE_SCOPE {
  PLAYERS_SEARCH_DATA_NAVBAR = 'PLAYERS_SEARCH_DATA_NAVBAR'
}

//COMBINE LOGGER FILTER

export const COMBINE_DRILLS: CombineDrillsType = [
   {
    groupSelected: 'QB',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType:'Skill Drills - QB', drill:'Radar Gun'},
      {drillType:'Skill Drills - QB', drill:'Drops and Throwing Motion (Back Out)'},
      {drillType:'Skill Drills - QB', drill:'Drops and Throwing Motion (3-Step)'},
      {drillType:'Skill Drills - QB', drill:'Drops and Throwing Motion (5-Step)'},
      {drillType:'Skill Drills - QB', drill:'Drops and Throwing Motion (7-Step)'},
      {drillType:'Skill Drills - QB', drill:'Drops and Throwing Motion (5-Step Wave)'},
      {drillType:'Skill Drills - QB', drill:'5-Step Roll Out'},
      {drillType:'Skill Drills - QB', drill:'Smoke/Now Route'},
      {drillType:'Skill Drills - QB', drill:'Slant Route (Left)'},
      {drillType:'Skill Drills - QB', drill:'Speed Out Route (Left)'},
      {drillType:'Skill Drills - QB', drill:'Dagger Route (Left)'},
      {drillType:'Skill Drills - QB', drill:'Circus Route (Left)'},
      {drillType:'Skill Drills - QB', drill:'Slot Strike Route (Left)'},
      {drillType:'Skill Drills - QB', drill:'Slot Sail Route (Right)'},
      {drillType:'Skill Drills - QB', drill:'Curl Route (Right)'},
      {drillType:'Skill Drills - QB', drill:'Go Route (Right)'},
      {drillType:'Skill Drills - QB', drill:'Comeback Route (Right)'},
      {drillType:'Skill Drills - QB', drill:'Post Corner Route (Right)'},
      {drillType:'Skill Drills - QB', drill:'Red Zone Fade (Right)'},
      {drillType:'Skill Drills - QB', drill: 'Alternate Skill Drills'},
    ]
  },
  {
    groupSelected: 'RB',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - RB', drill: 'Off Tackle Recognition (Right)'},
      {drillType: 'Skill Drills - RB', drill: 'Blast Read (Left)'},
      {drillType: 'Skill Drills - RB', drill: 'Duce Staley Drill'},
      {drillType: 'Skill Drills - RB', drill: 'Flat Route'},
      {drillType: 'Skill Drills - RB', drill: 'Texas Route'},
      {drillType: 'Skill Drills - RB', drill: 'Inside Route Pivot Off LB'},
      {drillType: 'Skill Drills - RB', drill: 'Inside Route Shake LB'},
      {drillType: 'Skill Drills - RB', drill: 'Flair Route (Right)'},
      {drillType: 'Skill Drills - RB', drill: 'Wheel Route (Left)'},
      {drillType: 'Skill Drills - RB', drill: 'Alternate Skill Drills'},

    ]
  },
  {
    groupSelected: 'WO',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - WR', drill: 'Over Shoulder Adjust'},
      {drillType: 'Skill Drills - WR', drill: 'Gauntlet Drill'},
      {drillType: 'Skill Drills - WR', drill: 'Slant Route (Left)'},
      {drillType: 'Skill Drills - WR', drill: 'Speed Out Route (Left)'},
      {drillType: 'Skill Drills - WR', drill: 'Dagger Route (Left)'},
      {drillType: 'Skill Drills - WR', drill: 'Circus Route (Left)'},
      {drillType: 'Skill Drills - WR', drill: 'Slot Strike Route (Left)'},
      {drillType: 'Skill Drills - WR', drill: 'Slot Sail Route (Right)'},
      {drillType: 'Skill Drills - WR', drill: 'Curl Route (Right)'},
      {drillType: 'Skill Drills - WR', drill: 'Go Route (Right)'},
      {drillType: 'Skill Drills - WR', drill: 'Comeback Route (Right)'},
      {drillType: 'Skill Drills - WR', drill: 'Post Corner Route (Right)'},
      {drillType: 'Skill Drills - WR', drill: 'Red Zone Fade (Right)'},
      {drillType: 'Skill Drills - WR', drill: 'Alternate Skill Drills'},

    ]
  },
  {
    groupSelected: 'TE',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - TE', drill: 'Over Shoulder Adjust'},
      {drillType: 'Skill Drills - TE', drill: 'Block Explosion'},
      {drillType: 'Skill Drills - TE', drill: 'Gauntlet Drill'},
      {drillType: 'Skill Drills - TE', drill: 'Flat Route (Left)'},
      {drillType: 'Skill Drills - TE', drill: 'In Route (Left)'},
      {drillType: 'Skill Drills - TE', drill: 'Hook Route (Right)'},
      {drillType: 'Skill Drills - TE', drill: 'Wheel Route (Left)'},
      {drillType: 'Skill Drills - TE', drill: 'Corner Route'},
      {drillType: 'Skill Drills - TE', drill: 'End Zone Fade (Right)'},
      {drillType: 'Skill Drills - TE', drill: 'Alternate Skill Drills'},

    ]
  },
  {
    groupSelected: 'OL',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - OL', drill: 'Five Yard Wave Drill (Slide and Shuffle)'},
      {drillType: 'Skill Drills - OL', drill: 'OL Pull Drill (Long Pull Right)'},
      {drillType: 'Skill Drills - OL', drill: 'OL Pull Drill (Deep Short Pull Left)'},
      {drillType: 'Skill Drills - OL', drill: 'OL Pull Drill (Fold Block Right)'},
      {drillType: 'Skill Drills - OL', drill: 'Pass Rush Drop'},
      {drillType: 'Skill Drills - OL', drill: 'Pass Pro-Mirror Drill'},
      {drillType: 'Skill Drills - OL', drill: 'Screen Drill'},
      {drillType: 'Skill Drills - OL', drill: 'Alternate Skill Drills'},
    ]
  },
  {
    groupSelected: 'LB',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - LB', drill: 'Wave Drill'},
      {drillType: 'Skill Drills - LB', drill: 'Four Bag Shuffle Drill'},
      {drillType: 'Skill Drills - LB', drill: 'Shuffle, Sprint, and COD Drill'},
      {drillType: 'Skill Drills - LB', drill: 'Pass Rush Drill'},
      {drillType: 'Skill Drills - LB', drill: 'Back Pedal and React'},
      {drillType: 'Skill Drills - LB', drill: 'Short Zone Break Forward'},
      {drillType: 'Skill Drills - LB', drill: 'Short Zone Break Inside'},
      {drillType: 'Skill Drills - LB', drill: 'Short Zone Break Flat Wheel'},
      {drillType: 'Skill Drills - LB', drill: 'Alternate Skill Drills'}
    ]
  },
  {
    groupSelected: 'DB',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},
      
      {drillType: 'Skill Drills - DB', drill: 'Line Drill'},
      {drillType: 'Skill Drills - DB', drill: 'Back Pedal and Transition 45 Degree Reaction'},
      {drillType: 'Skill Drills - DB', drill: 'W Drill'},
      {drillType: 'Skill Drills - DB', drill: 'Back Pedal and 90 Degree Break to Ball'},
      {drillType: 'Skill Drills - DB', drill: 'Teryl Austin Drill 1'},
      {drillType: 'Skill Drills - DB', drill: 'Teryl Austin Drill 2'},
      {drillType: 'Skill Drills - DB', drill: 'Box Drill'},
      {drillType: 'Skill Drills - DB', drill: 'Gauntlet Drill'},
      {drillType: 'Skill Drills - DB', drill: 'Alternate Skill Drills'},
      
    ]
  },
  {
    groupSelected: 'DL',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - DL', drill: 'Front Start Wave Drill and Lateral Reaction'},
      {drillType: 'Skill Drills - DL', drill: 'Four Bag Agility Drill'},
      {drillType: 'Skill Drills - DL', drill: 'Pass Rush Drill'},
      {drillType: 'Skill Drills - DL', drill: 'Run and Club Drill'},
      {drillType: 'Skill Drills - DL', drill: 'Run the Hoop Drill'},
      {drillType: 'Skill Drills - DL', drill: 'Body Control Drill'},
      {drillType: 'Skill Drills - DL', drill: 'Back Pedal and React'},
      {drillType: 'Skill Drills - DL', drill: 'Short Zone Break Forward'},
      {drillType: 'Skill Drills - DL', drill: 'Short Zone Break Inside'},
      {drillType: 'Skill Drills - DL', drill: 'Short Zone Break Flat Wheel'},
      {drillType: 'Skill Drills - DL', drill: 'Alternate Skill Drills'},
        
    ]
  },
  {
    groupSelected: 'PK',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - PK', drill: 'Straightaway Punts'},
      {drillType: 'Skill Drills - PK', drill: 'Directional Punts'},
      {drillType: 'Skill Drills - PK', drill: '50+ Punts'},
      {drillType: 'Skill Drills - PK', drill: 'Straightaway Kickoffs'},
      {drillType: 'Skill Drills - PK', drill: 'Directional Kickoffs'},
      {drillType: 'Skill Drills - PK', drill: 'Quick Elevation Kicks'},
      {drillType: 'Skill Drills - PK', drill: 'Field Goal 20 (Left Hash)'},
      {drillType: 'Skill Drills - PK', drill: 'Field Goal 23 (Middle)'},
      {drillType: 'Skill Drills - PK', drill: 'Field Goal 25 (Right Hash)'},
      {drillType: 'Skill Drills - PK', drill: 'Field Goal 30 (Left Hash)'},
      {drillType: 'Skill Drills - PK', drill: 'Field Goal 35 (Right Hash)'},
      {drillType: 'Skill Drills - PK', drill: 'Field Goal 40 (Left Hash)'},
      {drillType: 'Skill Drills - PK', drill: 'Field Goal 45 (Right Hash)'},
      {drillType: 'Skill Drills - PK', drill: 'Onside Kick'},
      {drillType: 'Skill Drills - PK', drill: 'Alternate Skill Drills'},
    ]
  },
  {
    groupSelected: 'LS',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},

      {drillType: 'Skill Drills - LS', drill: 'Straightaway Punts'},
      {drillType: 'Skill Drills - LS', drill: 'Directional Punts'},
      {drillType: 'Skill Drills - LS', drill: '50+ Punts'},
      {drillType: 'Skill Drills - LS', drill: 'Straightaway Kickoffs'},
      {drillType: 'Skill Drills - LS', drill: 'Directional Kickoffs'},
      {drillType: 'Skill Drills - LS', drill: 'Quick Elevation Kicks'},
      {drillType: 'Skill Drills - LS', drill: 'Field Goal 20 (Left Hash)'},
      {drillType: 'Skill Drills - LS', drill: 'Field Goal 23 (Middle)'},
      {drillType: 'Skill Drills - LS', drill: 'Field Goal 25 (Right Hash)'},
      {drillType: 'Skill Drills - LS', drill: 'Field Goal 30 (Left Hash)'},
      {drillType: 'Skill Drills - LS', drill: 'Field Goal 35 (Right Hash)'},
      {drillType: 'Skill Drills - LS', drill: 'Field Goal 40 (Left Hash)'},
      {drillType: 'Skill Drills - LS', drill: 'Field Goal 45 (Right Hash)'},
      {drillType: 'Skill Drills - LS', drill: 'Onside Kick'},
      {drillType: 'Skill Drills - LS', drill: 'Alternate Skill Drills'},
    ]
  },
  {
    groupSelected: 'Common',
    options: [
      {drillType: '40 Yard Dash',drill:'40 Yard Dash'},
      {drillType: '3 Cone Drill', drill:'3 Cone Drill'},
      {drillType:'Broad Jump', drill: 'Broad Jump'},
      {drillType:'Vertical Jump', drill: 'Vertical Jump'},
      {drillType:'Short Shuttle (20yd)', drill: 'Short Shuttle (20yd)'},
    ]
  },
  
];
export const DRILL_POSITIONS = {
  name: 'Position',
  types: [
    'QB',
    'RB',
    'WO',
    'TE',
    'OL',
    'DL',
    'LB',
    'DB',
    'PK',
    'LS'
  ],
  title: 'Position'
};